import { SEU_NEW_ID } from '@seu-helpers';
import {
  SeuInterconnection,
  SeuOperatingCondition,
  SeuOperatingConditionCategory,
} from '@seu-types';
import { neverError } from './never.helper';

export function getOperatingConditionCategoryLabel(
  key: SeuOperatingConditionCategory
): string {
  switch (key) {
    case 'WARRANTY':
      return 'operating-condition.types.warranty';
    case 'PART_LOAD':
      return 'operating-condition.types.part';
    case 'MAXIMUM_LOAD':
      return 'operating-condition.types.full';
    case 'NOMINAL':
      return 'operating-condition.types.nominal';
    case 'OTHER':
      return 'operating-condition.types.other';
    default:
      throw neverError(key);
  }
}

export function getHighestNumberOfInputStreams(
  operatingConditions: SeuOperatingCondition[]
): number {
  if (!operatingConditions?.length) {
    return 0;
  }

  return Math.max(
    ...operatingConditions.map((oc) => oc.inputStreams?.length ?? 0)
  );
}

export function hasInputStreamWarning(
  interconnection: SeuInterconnection,
  operatingConditionId: string
): boolean {
  if (operatingConditionId === SEU_NEW_ID) {
    return false;
  }
  const inputStreamsLength =
    interconnection.operatingConditions.find(
      (op) => op.id === operatingConditionId
    )?.inputStreams.length ?? 0;

  return interconnection.operatingConditions.some((op) => {
    return op.inputStreams.length > inputStreamsLength;
  });
}
